import { render, staticRenderFns } from "./eg_additional_collapse.vue?vue&type=template&id=5ce2fdbb&scoped=true&"
import script from "./eg_additional_collapse.vue?vue&type=script&lang=js&"
export * from "./eg_additional_collapse.vue?vue&type=script&lang=js&"
import style0 from "./eg_additional_collapse.vue?vue&type=style&index=0&id=5ce2fdbb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2fdbb",
  null
  
)

export default component.exports